import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ServiceValidationError } from '../../Core/DataTypes/ServiceValidation/ServiceValidationError';

declare var IS_RUNNING_IN_APP_POOL;

export class DocumentFileClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, fileName: string, useGenericFileName: boolean, documentId: number, taskRequestId: number, clAccountId: string, encrypt: boolean): Promise<string, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Documents/DocumentFile/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, fileName: fileName, useGenericFileName: useGenericFileName, documentId: documentId, taskRequestId: taskRequestId, clAccountId: clAccountId, encrypt: encrypt }

    return AjaxWrapper.get<string, any>(url, data);
  }
  public post(hierarchyId: string, documentId: number): Promise<Array<ServiceValidationError>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Documents/DocumentFile/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, documentId: documentId }

    return AjaxWrapper.post<Array<ServiceValidationError>, any>(url, data);
  }
}

